import * as React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, useLocation, withRouter } from "react-router-dom";
import App from "./App";
// import reportWebVitals from "./reportWebVitals";

import "antd/dist/antd.css";

const _ScrollToTop = (props: any) => {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return props.children;
};
const ScrollToTop = withRouter(_ScrollToTop);

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop>
      <App />
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
